import { Component } from '@angular/core';

@Component({
  selector: 'app-ripple-loader',
  templateUrl: './ripple-loader.component.html',
  styleUrl: './ripple-loader.component.scss'
})
export class RippleLoaderComponent {

}
